module.exports = __webpack_public_path__ + "img/the-social-mercenary.9d07c196.png";